import { sva } from "@agapi/ui/panda/css";

export const miniCartStyles = sva({
  slots: ['root', 'header', 'footer', 'content', 'progressBarRoot'],
  base: {
    root: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      borderLeftRadius: "5",
      top: "0",
      right: "0",
      ml: "auto",
      marginTop: "0px",
      width: "100%",
      zIndex: "12",
      overflowY: "scroll",
      scrollbarWidth: "none",
      overflowX: 'hidden',
      gap: "sm",
      bg: "surface.default.background",
    },
    footer: {
      display: "flex",
      flexDir: "column",
      px: "tight",
      pb: "3",
      pt: "tight",
      bg: "surface.primary.subdued.background",
      boxShadow: "1px 3px 9px 0px rgba(0, 0, 0, 0.20)",
      gap: "tight",
      borderRadius: "34px 34px 0px 0px",
      width: "100%",
      position: "sticky",
      bottom: "0",
      zIndex: "6",
      color: "surface.primary.subdued.foreground",
      mt: 'auto',
      mx: "auto",
    },
    header: {
      position: "sticky",
      display: "flex",
      flexDir: "row",
      justifyContent: "space-between",
      top: "0",
      px: "tight",
      pt: "5",
      pb: "3",
      zIndex: "10",
      alignItems: "center",
      bg: "surface.default.background",
    },
    progressBarRoot: {
      minHeight: "items.sm",
      bg: "surface.secondary.contrast.background",
      rounded: "full",
      maxWidth: "100%",
      transition: "0.2s ease",
    }
  }
});
